"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeUUID = exports.generateUUID = exports.hexString = exports.unhexMapper = exports.unhexString = exports.destructUUID = exports.addDashesToUUID = void 0;
const uuid_1 = require("uuid");
const addDashesToUUID = (u) => u.replace(/(\w{8})(\w{4})(\w{4})(\w{4})(\w{12})/, '$1-$2-$3-$4-$5').toLowerCase();
exports.addDashesToUUID = addDashesToUUID;
const destructUUID = (u) => u.toUpperCase().replace(/-/g, '');
exports.destructUUID = destructUUID;
const unhexString = (hexed) => {
    if (!hexed)
        throw Error('Empty String');
    return Buffer.from(hexed, 'hex');
};
exports.unhexString = unhexString;
const unhexMapper = (arr) => {
    const newArr = Array.isArray(arr) ? [...arr] : [arr];
    return newArr.map((hexed) => (0, exports.unhexString)(hexed));
};
exports.unhexMapper = unhexMapper;
const hexString = (str) => {
    if (!str)
        throw Error('Empty UUID');
    return str.toString('hex').toUpperCase();
};
exports.hexString = hexString;
const generateUUID = () => (0, uuid_1.v4)().replace(/-/g, '').toUpperCase();
exports.generateUUID = generateUUID;
/**
 * Takes in any UUID (regular string, hexed string, or Buffer) and returns all
 * representations of the UUID.
 */
const decodeUUID = (value) => {
    const input = Buffer.isBuffer(value) ? value.toString('hex').toUpperCase() : value;
    if (!input || ![32, 36].includes(input.length)) {
        throw new Error('Missing or invalid UUID provided to decoder');
    }
    return {
        buffer: (0, exports.unhexString)((0, exports.destructUUID)(input)),
        hex: (0, exports.destructUUID)(input),
        uuid: (0, exports.addDashesToUUID)(input),
    };
};
exports.decodeUUID = decodeUUID;
